import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ToasterServiceService } from '../../../service/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { MainService } from '../../../service/main.service';
import { LocalStorageService } from '../../../service/local-storage.service';
import { CommonModule, Location } from '@angular/common';
import { ApiUrls } from '../../../apiRouts';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { SharedModule } from '../../../shared/shared.module';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
@Component({
  selector: 'app-add-event-donor',
  templateUrl: './add-event-donor.component.html',
  styleUrl: './add-event-donor.component.scss'
})
export class AddEventDonorComponent implements OnInit{
  memberListDataMain: any = [];
  memberFilterData: any = [];
  userIds: any = [];
  userId: any;
  sub2 = new Subscription;
  subEventId: any;
  @ViewChild('selectAllCheckbox1') selectAllCheckbox1!: MatCheckbox;

  constructor(
    private toasterService: ToasterServiceService,
    private _bottomSheet: MatBottomSheet,
    private location: Location,
    private route: ActivatedRoute,
    private mainService: MainService,
    private localStorageService: LocalStorageService,    
  ) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {
      this.memberFilterData = this.memberListDataMain.filter((user: any) => {
        // if (user.blood_group > '0' && user.village_name != '0' && user.contact_no) {
        //   return user.blood_group.toLowerCase().includes(res.blood_group.toLowerCase()) &&
        //     user.village_name.toLowerCase().includes(res.village_name.toLowerCase()) &&
        //     user.contact_no.toLowerCase().includes(res.contact_no)
        // }
        // if (user.blood_group && user.village_name != '0') {
        //   return user.blood_group.toLowerCase().includes(res.blood_group) &&
        //     user.village_name.toLowerCase().includes(res.village_name)
        // }
        // if (user.blood_group && user.contact_no) {
        //   return user.blood_group.toLowerCase().includes(res.blood_group) &&
        //     user.contact_no.toLowerCase().includes(res.contact_no)
        // }
        // if (user.village_name != '0' && user.contact_no) {
        //   return user.village_name.toLowerCase().includes(res.village_name) &&
        //     user.contact_no.toLowerCase().includes(res.contact_no)
        // }

        // if (user.blood_group > '0') {
        //   return user.blood_group.toLowerCase().includes(res.blood_group)
        // }

        // if (user.village_name! = '0') {
        //   return user.village_name.toLowerCase().includes(res.village_name)
        // }

        // if (user.contact_no) {
        //   return user.contact_no.toLowerCase().includes(res.contact_no)
        // }

        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();
        const villageNameMatch = !res.village_name || user.village_name.toLowerCase().includes(res.village_name.toLowerCase());
        const educationMatch = !res.education || user.education.toLowerCase().includes(res.education.toLowerCase());
        const currentCityMatch = !res.city_name || user.city_name.toLowerCase().includes(res.city_name.toLowerCase());
        const SubdivisionMatch = !res.subdivision_name || user.subdivision_name.toLowerCase().includes(res.subdivision_name.toLowerCase());
        // const contactNoMatch = !res.contact_no || user.contact_no.toLowerCase().includes(res.contact_no.toLowerCase());
        // const userContactNoTrimmed = user.contact_no.toString().trim().toLowerCase();
        // const resContactNoTrimmed = res.contact_no.toString().trim().toLowerCase();
        // const contactNoMatch = !res.contact_no || userContactNoTrimmed === resContactNoTrimmed;
        // return bloodGroupMatch && villageNameMatch && contactNoMatch;
        return bloodGroupMatch && villageNameMatch && educationMatch && currentCityMatch  && SubdivisionMatch;
      });

    })
  }

  ngOnInit() {
    this.getMainMember();
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.memberFilterData,
    });
  }

  getMainMember() {
    let data = {
      user_id: Number(this.subEventId),
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'SELECTNONSUBEVENTDONOR',
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.memberListDataMain = res.user;
        this.memberFilterData = res.user;
      }
    });
  }

  goBackToPrevPage() {
    this.location.back();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.memberFilterData = this.memberListDataMain
      return;
    }
    this.memberFilterData = this.memberListDataMain.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue)
    });
  }

  selectAllMembers(event: any) {
    if (event.checked) {
      // Select all checkboxes
      this.memberFilterData.forEach((member: any) => {
        member.checked = true;
        if (!this.userIds.includes(member.user_id)) {
          this.userIds.push(member.user_id);
        }
      });
    } else {
      // Deselect all checkboxes
      this.memberFilterData.forEach((member: any) => {
        member.checked = false;
      });
      this.userIds = [];
    }
  }

  
  invitationFunction(event: any, userId: any) {
    if (event.checked) {
      if (!this.userIds.includes(userId)) {
        this.userIds.push(userId);
      }
    } else {
      this.userIds = this.userIds.filter((id: any) => id !== userId);
    }
  }

  submit() {
    const stringArray = this.userIds.map((num: any) => `${num}`);
    const resultString = '[' + stringArray.join(',') + ']';
    var data: any = {
      sub_event_donor_id: 0,
      sub_event_id: Number(this.subEventId),
      user_ids_json: resultString,
      created_by: this.userId,
      Action: 'INSERT'
    }
    this.mainService.postApi(ApiUrls.addEventDonor, data, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.goBackToPrevPage();
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}

@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm {  
  filter_memberForm: FormGroup;
  villageListAll: any = [];
  cityListAll: any = [];
  SubdivisionAll: any = [];
  constructor(private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService, private fb: FormBuilder) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      village_name: [''],
      contact_no: [''],
      education: [''],
      city_name: [''],
      maternal_village_name: [''],
      subdivision_name: [''],
    })   

    this.getCurrentCityNameList();
    this.getVillageList();
    this.getSubdivisionDataList();
  }

  getCurrentCityNameList() {
    this.mainService.getApi(ApiUrls.cityList).subscribe((res: any) => {
      this.cityListAll = res.city;
    });
  }

  getVillageList() {
    this.mainService.getApi(ApiUrls.getAllVillageList).subscribe((res: any) => {
      this.villageListAll = res.village;
    });
  }
  
  getSubdivisionDataList() {
    this.mainService.getApi(ApiUrls.AllSubdivisionList).subscribe((res: any) => {
      this.SubdivisionAll = res.subdivision;
    });
  }

  Cancel(){
    this._bottomSheetRef.dismiss();
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      village_name: this.filter_memberForm.value.village_name,
      contact_no: this.filter_memberForm.value.contact_no,
      education: this.filter_memberForm.value.education,
      city_name: this.filter_memberForm.value.city_name,
      subdivision_name: this.filter_memberForm.value.subdivision_name,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

  openLink(event: MouseEvent): void {
    //  this._bottomSheetRef.dismiss();
    //   event.preventDefault();
  }
}
